import React, { useState, useEffect } from "react";
import validator from "validator";
import axios from "axios";
import imageCompression from "browser-image-compression";
import { useAuth } from "../contexts/auth";
import { postUpdateServiceURL } from "../utils/api";
import {
    Flex,
    Spacer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Text,
    RadioGroup,
    Radio,
    HStack,
    Box,
    InputRightElement,
} from "@chakra-ui/react";
import { Separator } from "components/Separator/Separator";
import SearchProduct from "../views/Custom/SearchProduct";

function CreateService({
    isOpen,
    onClose,
    successCallback,
    serviceData
}) {

    const [ title, setTitle ] = useState('');
    const [ description, setDescription ] = useState('');
    const [ isPublic, setIsPublic ] = useState('Yes');
    const [ isArchived, setIsArchived ] = useState('No');
    const [ imageFile, setImageFile ] = useState(null);
    const [ price, setPrice ] = useState("0.0");
    const [ addedProducts, setAddedProducts ] = useState([]);

    const [ invTitle, setInvTitle ] = useState(null);
    const [ invDescription, setInvDescription ] = useState(null);
    const [ invPrice, setInvPrice ] = useState(null);

    const { auth } = useAuth();
    const [ errors, setErrors ] = useState([]);
    const [ submitting, setSubmitting ] = useState(false);

    const postServices = async (e) => {
        e.preventDefault();

        setSubmitting(true);

        let id;
        if (serviceData) {
            id = serviceData.id;
        } 

        let cover;
        if (imageFile) {

            let compressedFile;
            const options = {
                maxSizeMB: 1,
                maxWidthOrHeight: 300,
                useWebWorker: true
            }
            try {
                compressedFile = await imageCompression(imageFile, options);
                // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
                // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
            } catch (error) {
                setErrors(['Failed compressing image.']);
                // console.log(error);
            }

            if (!compressedFile) {
                setSubmitting(false);
                return;
            }

            cover = await fileToBase64(compressedFile);
            cover = cover.replace('data:image/png;base64,', '');
            cover = cover.replace('data:image/jpeg;base64,', '');
            cover = cover.replace('data:image/jpg;base64,', '');
        }
     
        
        setErrors([]);
        // console.log(cover);

        // console.log(description, password);
        axios.post(postUpdateServiceURL(id), {
            title,
            description,
            isPublic: isPublic == 'Yes',
            isArchived: isArchived == 'Yes',
            price,
            cover: imageFile != null ? cover : undefined, 
            products: addedProducts.map(i => i.id),
        },{
            headers: {
                Authorization: `Bearer ${auth.authToken}`
            }
        }).then(result => {
            if (result.status === 200) {
                // const roles = result.data.data.user.roles;
                const user = result.data.data;
                // console.log(user);
                if (successCallback) {
                    successCallback();
                }
                setTitle('');
                setDescription('');
                setIsPublic('Yes');
                setImageFile(null);
                setPrice("0.0");
                setAddedProducts([]);
                onClose();
            } else {
                setErrors(result.data.errors);
            }
        }).catch(e => {
            if (e.response === undefined) {
                setErrors(['Could not connect to server!'])
            } else {
                setErrors(e.response.data.errors)
            }
        }).finally(e => {
            setSubmitting(false);
        });
    }

    useEffect(() => {


        if (!validator.isEmpty(title)) {
            setInvTitle(title.length < 1);
        }

        if (!validator.isEmpty(description)) {
            setInvDescription(description.length < 1);
        }

        if (!validator.isEmpty(price)) {
            setInvPrice(!validator.isNumeric(price));
        }

    }, [title, description, price]);

    useEffect(() => {
        // console.log(serviceData);

        if (serviceData && isOpen) {
            setTitle(serviceData.title);
            setDescription(serviceData.description);
            setPrice(serviceData.price);
            setIsPublic(serviceData.isPublic ? 'Yes' : 'No');
            setIsArchived(serviceData.isDeleted ? 'Yes' : 'No');
            setAddedProducts(serviceData.completeProducts);
            setErrors([]);
        }

    }, [serviceData, isOpen]);

    const fileToBase64 = async (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = (e) => reject(e)
        }
    );

    const onProductClicked = (product) => {
        const tmp = [...addedProducts];
        let alreadyIn = false;
        addedProducts.forEach(i => {
            if (i.id == product.id) {
                alreadyIn = true;
            }
        });
        
        if (!alreadyIn) {
            tmp.push(product);
            setAddedProducts(tmp);
        }
    }

    const removedAddedProduct = (product) => {
        const tmp = addedProducts.filter(ap => ap.id !== product.id);
        setAddedProducts(tmp);
    }


    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Update Service Details</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <form onSubmit={postServices}>
                        <FormControl >
                            {/* Title */}
                            <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    Title
                                </FormLabel>
                                <Input
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="Title"
                                    size="md" 
                                    isInvalid={invTitle === true}
                                    isRequired={true}
                                    value={title} 
                                    onChange={e => setTitle(e.target.value)}
                                />
                            </Box>
                            
                            
                            {/* Description */}
                            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                Description
                            </FormLabel>
                            <Input
                                borderRadius="15px"
                                mb="12px"
                                fontSize="sm"
                                type="text"
                                placeholder="Enter Description Address"
                                size="md" 
                                isInvalid={invDescription === true}
                                isRequired={true}
                                value={description} 
                                onChange={e => setDescription(e.target.value)}
                            />

                            {/* Price */}
                            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                Price
                            </FormLabel>
                            <Input
                                borderRadius="15px"
                                mb="12px"
                                fontSize="sm"
                                type="text"
                                placeholder="Enter Price"
                                size="md" 
                                isInvalid={invPrice === true}
                                isRequired={true}
                                value={price} 
                                onChange={e => setPrice(e.target.value)}
                            />

                            
                            {/* Icon */}
                            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                Icon (50x50)
                            </FormLabel>
                            <Input
                                borderRadius="15px"
                                mb="12px"
                                fontSize="sm"
                                type="file"
                                accept="image/*"
                                placeholder="Select Image"
                                size="md" 
                                textAlign="start" 
                                verticalAlign="middle"
                                // isInvalid={invDescription === true}
                                isRequired={false}
                                onChange={e => setImageFile(e.target.files[0])}
                            />


                                
                            {/* isPublic */}
                            <FormLabel as="legend">Show on Homepage</FormLabel>
                            <RadioGroup 
                                defaultValue="Male" mb="12px" 
                                onChange={setIsPublic}
                                value={isPublic}
                            >
                                <HStack spacing="24px">
                                    <Radio value="Yes">Yes</Radio>
                                    <Radio value="No">No</Radio>
                                </HStack>
                            </RadioGroup>

                            {/* isPublic */}
                            <FormLabel as="legend">Archive</FormLabel>
                            <RadioGroup 
                                defaultValue="Male" mb="12px" 
                                onChange={setIsArchived}
                                value={isArchived}
                            >
                                <HStack spacing="24px">
                                    <Radio value="Yes">Yes</Radio>
                                    <Radio value="No">No</Radio>
                                </HStack>
                            </RadioGroup>

                            {/* Added Products */}
                            <FormControl marginBottom="12px">
                                <Text fontSize="sm" color="gray.400" fontWeight="bold">
                                    ADDED ITEMS
                                </Text>
                                { addedProducts.length > 0 
                                    ?  <Flex flexDirection="column" w="100%">
                                        { addedProducts.map((ap) => {
                                            return <>
                                                <Flex flexDirection="row" w="100%">
                                                    <Box 
                                                        className="row" 
                                                        ml="12px" mr="12px" 
                                                        key={`added-prods-${ap.id}`}
                                                        >{ap.name}
                                                    </Box>
                                                    <Button
                                                    fontSize="8px"
                                                        size="xs"
                                                        colorScheme="red" variant="link"
                                                        onClick={() => removedAddedProduct(ap)}
                                                        >
                                                        remove
                                                    </Button>
                                                </Flex>
                                            <Separator />
                                            </>
                                        })}
                                    </Flex>
                                    : <Text>-</Text>
                                }
                            </FormControl>

                            <SearchProduct 
                                onClickProduct={onProductClicked}
                            />


                            <Flex w="100%" flexDir="column">
                                { errors.length > 0 && <Text color="red">{errors[0]}</Text> }
                            </Flex>
                            <Button
                                fontSize="10px"
                                type="submit"
                                bg="teal.300"
                                w="100%"
                                h="45"
                                mb="20px"
                                color="white"
                                mt="0px"
                                _hover={{
                                bg: "teal.200",
                                }}
                                _active={{
                                bg: "teal.400",
                                }}
                                isDisabled={submitting}
                            >
                                SAVE
                            </Button>
                        </FormControl>
                    </form>
                </ModalBody>
            </ModalContent>
        </Modal>
    );

}



export default CreateService;
